import React from 'react';
import styled from 'styled-components/macro'

const StyledHeader = styled.div`
  padding: 40px 20px 12px;
  margin: 0;
  color: ${({theme}) => theme.color};
  background-color: ${({theme}) => theme.bg};
  border-bottom: 1px solid ${({theme}) => theme.color};;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`

const Title = styled.h1`
  font-size: 20px;
  font-weight: 500;
  text-align: left;
  margin: 0px;
`

const Version = styled.h1`
  font-size: 20px;
  font-weight: 500;
  text-align: left;
  margin: 0px;
`

const Header = props => {
  return (
    <StyledHeader>
      <Title>Framo Playground</Title>
      <Version></Version>
    </StyledHeader>
  )
}

export default Header;